import { Badge, Box, MantineColor } from '@mantine/core';

const statusColors: Record<string, MantineColor> = {
  // Orders
  draft: 'gray',
  confirmed: 'blue',
  processing: 'indigo',
  shipped: 'violet',
  delivered: 'brand',
  cancelled: 'red',

  // PO
  submitted: 'blue',
  approved: 'green',
  rejected: 'red',
  receiving: 'orange',
  completed: 'brand',

  // General
  active: 'green',
  inactive: 'gray',
  locked: 'red',
  on_leave: 'yellow',

  // Compliance
  certified: 'green',
  pending: 'yellow',
  expired: 'red',
  none: 'gray',
  resolved: 'brand',
  monitoring: 'orange',
  scheduled: 'blue',
  in_progress: 'indigo',
  findings: 'orange',

  // Severity
  low: 'blue',
  medium: 'yellow',
  high: 'orange',
  critical: 'red',

  // Receiving condition
  good: 'green',
  damaged: 'orange',

  // Pallets
  in_transit: 'blue',
  empty: 'gray',

  // Expiration
  fresh: 'green',
  expiring_soon: 'yellow',

  // PACA
  current: 'green',
  at_risk: 'yellow',
  overdue: 'red',

  // Cold chain
  normal: 'green',
  warning: 'orange',

  // GAP/GMP
  pass: 'green',
  conditional: 'yellow',
  fail: 'red',

  // GFSI NCs
  open: 'orange',
  closed: 'brand',

  // Exception Queue
  acknowledged: 'blue',
  dismissed: 'gray',
  info: 'blue',

  // Customer Portal
  pending_approval: 'yellow',

  // GL Approval Workflow
  pending_review: 'yellow',
  auto_approved: 'green',
  posted: 'green',
  reversed: 'orange',

  // Fixed Assets
  fully_depreciated: 'gray',
  disposed: 'red',

  // Environmental Monitoring
  positive: 'red',
  negative: 'green',

  // LGMA
  suspended: 'orange',
  revoked: 'red',

  // Organic
  verified: 'green',

  // HACCP hazards
  significant: 'red',
};

interface StatusBadgeProps {
  status: string;
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  variant?: 'filled' | 'light' | 'outline' | 'dot';
}

export default function StatusBadge({
  status,
  size = 'sm',
  variant = 'light',
}: StatusBadgeProps) {
  const normalized = (status || 'unknown').toLowerCase().replace(/\s+/g, '_');
  const color = statusColors[normalized] || 'gray';
  const display = (status || 'Unknown').replace(/_/g, ' ');

  return (
    <Badge
      color={color}
      size={size}
      variant={variant}
      tt="capitalize"
      leftSection={
        <Box
          style={{
            width: 6,
            height: 6,
            borderRadius: '50%',
            backgroundColor: `var(--mantine-color-${color}-6)`,
          }}
        />
      }
    >
      {display}
    </Badge>
  );
}
